import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Btn } from "@/ui/btn/Btn";
import { Dialog } from "@/ui/dialog/Dialog";
import { Input } from "@/ui/input/Input";
import { useCalculator } from "../../../hooks/useCalculator";
import { useCalculatorPromoCode } from "../../../hooks/useCalculatorPromoCode";
import styles from "./CalculatorPromoCodeDialog.module.css";

export const CalculatorPromoCodeDialog = () => {
  const setPromoCodeDialogOpen = useCalculator(
    (state) => state.setPromoCodeDialogOpen,
  );
  const setPromoCode = useCalculator((state) => state.setPromoCode);

  const [value, setValue] = useState("");

  const { t } = useTranslation();

  const { data, error, trigger, isMutating, reset } =
    useCalculatorPromoCode(value);

  const onConfirm = () => {
    reset();

    trigger();
  };

  const onClose = () => {
    reset();
    setPromoCodeDialogOpen(false);
  };

  useEffect(() => {
    if (data !== undefined && data.error === undefined) {
      setPromoCode(value);
      setPromoCodeDialogOpen(false);
    }
  }, [data, setPromoCode, setPromoCodeDialogOpen, value]);

  return (
    <Dialog className={styles.dialog} onClose={onClose}>
      <Dialog.Header>
        <Dialog.Title>
          <Trans>Promo code</Trans>
        </Dialog.Title>
        <Dialog.Close />
      </Dialog.Header>
      <Dialog.Body>
        <Input
          icon="gift_24px_light"
          value={value}
          placeholder={t("Enter promo code")}
          error={error}
          loading={isMutating === true}
          onChange={setValue}
        />
      </Dialog.Body>
      <Dialog.Footer>
        <Btn
          icon="confirm_24px_filled"
          text={t("Activate")}
          disabled={value.trim().length === 0 || isMutating === true}
          onClick={onConfirm}
        />
        <Dialog.Context.Consumer>
          {(dialog) => (
            <Btn
              icon="cancel_24px_filled"
              text={t("Cancel")}
              mode="cancel"
              onClick={() => dialog.close()}
            />
          )}
        </Dialog.Context.Consumer>
      </Dialog.Footer>
    </Dialog>
  );
};
